import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
The Twelve Precincts (12Ps) are administered under the MSA program but are not located in the MSA Levy Area. No levy applies to the 12Ps, but they will have other specific biodiversity offset requirements. Please contact{' '} <InlineLink href="mailto:msa.habitatcompensation@delwp.vic.gov.au" text="msa.habitatcompensation@delwp.vic.gov.au" mdxType="InlineLink" /> for land parcel specific information.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      